import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AppNavbar from "./components/Client/Navbar/AppNavbar";
import FreeShippingHeader from "./components/Client/FreeShippingHeader/FreeShippingHeader";
import HeroSection from "./components/Client/HeroSection/HeroSection";
import CategoriesSection from "./components/Client/Categories/CategoriesSection";
import FeaturedProductsCarousel from "./components/Client/FeaturedProducts/FeaturedProductsCarousel";
import UploadDesignSection from "./components/Client/UploadDesign/UploadDesignSection";
import Footer from "./components/Client/Footer/Footer";
import ProductsPage from "./pages/ProductsPage/ProductsPage";
import ProductDetail from "./pages/ProductDetail/ProductDetail";
import CartPage from "./pages/CartPage/CartPage";
import CheckoutPage from "./pages/CheckoutPage/CheckoutPage";
import { CartProvider } from "./components/Client/context/CartContext";
import ManagementNavbar from "./components/Management/ManagementNavbar/ManagementNavbar"; // Importar el nuevo ManagementNavbar

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <TransitionGroup>
      <CSSTransition key={location.key} classNames="slide" timeout={300}>
        <Routes location={location}>
          <Route
            path="/"
            element={
              <>
                <div className="hero-container">
                  <HeroSection />
                </div>
                <CategoriesSection />
                <FeaturedProductsCarousel />
                <UploadDesignSection />
              </>
            }
          />
          <Route path="/productos" element={<ProductsPage />} />
          <Route path="/productos/:id" element={<ProductDetail />} />
          <Route path="/carrito" element={<CartPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route
            path="/management"
            element={
              <>
                <ManagementNavbar /> {/* Aquí se agrega el nuevo navbar */}

              </>
            }
          />
        </Routes>
      </CSSTransition>
    </TransitionGroup>
  );
}

function App() {
  return (
    <CartProvider>
      <Router>
        <div>
          <FreeShippingHeader />
          <AppNavbar />
          <AnimatedRoutes />
          <Footer />
          <ToastContainer position="top-right" autoClose={3000} />
        </div>
      </Router>
    </CartProvider>
  );
}

export default App;
